// extracted by mini-css-extract-plugin
export var createdDate = "_i3-1";
export var divider = "_i3-2";
export var headerDivider = "_i3-3";
export var messagesCard = "_i3-0";
export var messagesContainer = "_i3-6";
export var messagesContainerWrapper = "_i3-4";
export var showLeftPanelButton = "_i3-8";
export var topButtons = "_i3-7";
export var withPadding = "_i3-5";